import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getCityList } from "../../../../redux/slices/hotel";
import { useSelector, useDispatch } from "react-redux";
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText, ListSubheader } from "@mui/material";
import AttractionsIcon from '@mui/icons-material/Attractions';
import { InputAdornment } from "@mui/material";
import Image from "next/image";

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue, label,
  placeholder,
  setLoading,
  loading,
  autocompleteNext,
  focusNext,
  error,
  helperText
}) => {
  const dispatch = useDispatch();

  const { cityListRes } = useSelector((state) => state.hotel);
  const [cityList, setCityList] = useState([]);



  useEffect(() => {
    dispatch(getCityList({ search: "" }));
  }, []);

  useEffect(() => {
    if (cityListRes) {
      setCityList(cityListRes.cityList);
    }
  }, [cityListRes]);


  const flattenedOptions = cityValue.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.values.map((value) => ({
        group: curr.label,
        img: curr.img,
        ...value
      })),
    ];
  }, []);

  return (

    <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
      sx={{
        "& label.Mui-focused": {
          color: "black",
        },

        "& .MuiListSubheader-root": {
          // height: "16px",
          backgroundColor: 'red',

        },
        "& .MuiInputBase-input": {
          // height: "16px",
        },
        "& .MuiAutocomplete-clearIndicator": {
          display: "none", // Hides the clear (close) button
        },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiInput-underline:after": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiAutocomplete-listbox": {
          overflow: "hidden"
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
            borderRadius: "8px",
          },
          "&:hover fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
        },
        '&::-webkit-scrollbar': {
          width: '2px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '6px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
      }}>

      <Autocomplete
        value={selectedValue}
        onChange={(event, newValue) => {
          setSelectedValue(newValue); // Update the selected value in state
        }}
        onInputChange={(event, newInputValue) =>
          setSearchProduct(newInputValue)
        }
        loading={loading}
        noOptionsText="No results found"
        options={flattenedOptions}
        groupBy={(option) => option.group}
        getOptionLabel={(option) => option.name} // Display name as the label in the input
        renderInput={(params) => (
          <TextField {...params} label={label} placeholder={placeholder}

            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <AttractionsIcon />
                </InputAdornment>
              ),
              style: error ? { borderColor: 'red' } : {},
            }}
            error={error}
            helperText={helperText}
          />
        )}

        renderOption={(props, option) => (


          <ListItem {...props} >
            <div style={{
              minWidth: '35px',
              textAlign: 'left'
            }}>
              <Image
                height="100"
                width="100"
                style={{
                  width: '20px',
                  height: '20px'
                }} alt={option.name} src={option.img} />
            </div>
            <ListItemText sx={{
              fontSize: '12px'
            }} primary={option.name} />
          </ListItem>

        )}

      />
    </Box>

  );
};

export default HotelDestination;